<div class="modal-content modal-xl text-white bg-am-premium-blue" style="background: transparent !important;">
  <div class="d-flex position-text justify-content-center p-4 bg-am-premium-blue">
    <div class="margin-title fs-52px">
      {{ 'chooseLanguage' | translate}}
    </div>
    <div class="bg-am-premium-blue am-close-div">
      <button type="button" class=" text-am-white am-modal-close" (click)="modal.dismiss()">
        <img src="../../../../assets/images/close.svg" alt="close" >
      </button>
    </div>
  </div>
  <div class="bg-am-premium-blue lenguages-list">
    <app-choose-language (select)="onSelected($event)"></app-choose-language>
  </div>
</div>
